import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  return (
    <CFooter className="px-4">
      <div>
        <span>&copy; 2003 - 2026 Cybertronica. Todos los derechos reservados.</span>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
